<template>
  <div class="d-flex flex-column flex-fill">
    <!-- {{specdata}}-sss -->
    <!-- 單一模式 -->
    <div v-if="stockStatus === 1">
      <div class="d-flex flex-column flex-fill">
        <div class="d-flex flex-column p-3 border-bottom">
          <div class="d-flex align-items-center pl-3 pt-3">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">
              庫存管理模式：{{single.list |filter({value:single.method})[0].name}}
              <small v-if='specdata.speCheck'>
                <a href="#" @click='single.method=list.value' v-if='single.method != list.value'
                  v-for='list in single.list' :key='"SAAA__"+list.value'>{{list.name}}</a>
              </small>
            </span>
          </div>
          <!-- 商品總庫存 -->
          <div class='mt-2'>
            <div class="d-flex align-items-center pl-3 ">
              <font-awesome-icon :icon="['fas', 'play']" />
              <span class="pl-3">商品總庫存：</span>
              <div style='width:80px;'>
                <b-input type='number' size='sm' class='text-right'
                  :value='thdata.product.inventory'
                  @input='changeinput("inventory",$event,"product")'></b-input>
              </div>
            </div>
            <div class="pl-5 mt-2">
              <div class="d-flex align-items-center ">
                <b-form-checkbox v-model="thdata.product.stopselling.check" :value="1"
                  :unchecked-value="0">
                  安全庫存停賣點：
                </b-form-checkbox>
                <div style='width:100px;'>
                  <b-input type='number' size='sm' class='text-right'
                    v-model="thdata.product.stopselling.number">
                  </b-input>
                </div>
                <span>（當設定安全停賣點 = 不超賣）</span>
              </div>
              <div class="d-flex  align-items-center mt-2">
                <b-form-checkbox v-model="thdata.product.showinventory.show" :value="1"
                  :unchecked-value="0">
                  是否顯示庫存量：
                </b-form-checkbox>
                <div style='width:80px;'>
                  <b-input type='number' size='sm' class='text-right'
                    v-model="thdata.product.showinventory.setshownumber">
                  </b-input>
                </div>
                <div>（不填寫帶實際庫存，填寫帶自定義庫存）</div>
              </div>
              <div class="d-flex align-items-center mt-2">
                <b-form-checkbox v-model="thdata.product.showinventory.showonlinedate" :value="1"
                  :unchecked-value="0">
                  顯示上架日
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <!-- ============= -->
          <!-- 項目庫存 -->
          <div>
            <div class="d-flex align-items-center pl-3 pt-3">
              <font-awesome-icon :icon="['fas', 'play']" />
              <span class="pl-3">項目庫存</span>
            </div>
            <div class='w-100 mt-2 pr-5'>
              <div class='pb-2 text-left'>
                <div class='d-flex'>
                  <button class='btn btn-sm btn-primary'
                    @click='openselectElement("editEle","insert",basedata)'>新增項目</button>
                  <button class='btn btn-sm btn-primary ml-1'
                    @click='openselectElement("selectEle","select",basedata)'>加入現有項目</button>
                </div>
              </div>
              <table class='table table-bordered'>
                <thead>
                  <tr>
                    <th></th>
                    <th>項目代號</th>
                    <th>項目名稱</th>
                    <th style='width:80px;'>數量</th>
                    <th style='width:100px;'>顯示於前台</th>
                    <th>顯示備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='(item,$index) in findEle(basedata)'>
                    <td>{{$index+1}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <td>
                      <b-input type='number' v-model='item.number'></b-input>
                    </td>
                    <td>
                      <b-form-checkbox v-model='item.webshow' :value="1" :unchecked-value="0"
                        :class='{"text-success":item.webshow,"text-danger":!item.webshow}'>
                        {{item.webshow?"顯示":'不顯示'}}
                      </b-form-checkbox>
                    </td>
                    <td>
                      <b-form-checkbox v-model='item.showremark' :value="1" :nchecked-value="0"
                        :class='{"text-success":item.showremark,"text-danger":!item.showremark}'>
                        {{item.showremark?"顯示":'不顯示'}}
                      </b-form-checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- ======================= -->
        </div>

      </div>
    </div>
    <!-- multiple/Case -->
    <div class="d-flex flex-fill align-items-center " v-if="stockStatus === 2 || stockStatus === 3">

      <font-awesome-icon :icon="['fas', 'play']" />
      <span class="pl-3">庫存管理模式：</span>
      <div v-if="nowSpecification === 'multiple'">
        規格庫存
      </div>
      <div v-if="nowSpecification === 'case'">
        項目庫存
        <!-- <select v-model="stockStatus" class="custom-select">
          <option :value="2">規格庫存</option>
          <option :value="3">元素庫存</option>
        </select> -->
      </div>
    </div>
    <!--  -->
    <div v-if="stockStatus === 2">
      <div class="d-flex flex-column flex-fill">
        <div class="d-flex flex-column p-3 border-bottom">
          <!-- <div class="d-flex align-items-center pl-3 pt-3">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">庫存管理模式：</span>

   

            <div v-else-if="nowSpecification === 'case'">
              <select v-model="stockStatus">
                <option :value="2">規格庫存</option>
                <option :value="3" selected>元素庫存</option>
              </select>
            </div>
          </div> -->
          <div class="d-flex flex-column align-items-start pl-3">
            <!-- <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="sotckCheck5" />
              <label class="form-check-label" for="sotckCheck5">是否顯示庫存量</label>
            </div> -->
            <!-- <div class="d-flex align-items-center mt-1">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value id="sotckCheck6" />
                <label class="form-check-label" for="sotckCheck6">自訂庫存量</label>
              </div>
              <div>
                <b-input></b-input>
              </div>
            </div> -->
            <div class="d-flex align-items-center  mb-1">
              <b-form-checkbox id="checkbox-1" v-model="thdata.product.showonlinedate" :value="1"
                :unchecked-value="0">
                顯示上架日
              </b-form-checkbox>
            </div>
          </div>

          <span class=" align-self-start">【規格庫存表】</span>
          <div style="width:700px;">
            <table class="table table-bordered overflow-auto">
              <thead align="left">
                <tr>
                  <th colspan="2"></th>
                  <th>規格項目</th>
                  <th>使用庫存</th>
                  <th>庫存量</th>
                  <th>安全停賣點</th>
                </tr>
              </thead>
              <tbody align="left">
                <tr>
                  <td>(主)</td>
                  <td>
                    <button type="button" class="btn btn-outline-secondary">編輯</button>
                  </td>
                  <td>{{basedata.smallname}}</td>
                  <td>
                    <div v-if='!thdata.spec[basedata.uid]' class='text-danger'>
                      不使用
                    </div>
                    <b-form-checkbox v-model="matchCost(basedata.uid).use"
                      v-if='thdata.spec[basedata.uid]'
                      :class="{'text-success':matchCost(basedata.uid).use,'text-danger':!matchCost(basedata.uid).use}"
                      :value="1" :unchecked-value="0">
                      {{matchCost(basedata.uid).use?"使用":"不使用"}}
                    </b-form-checkbox>
                  </td>
                  <td>{{matchCost(basedata.uid).cargonumber}}</td>
                  <td>{{matchCost(basedata.uid).selfcargo}}</td>
                </tr>
                <tr v-for='item in specdata.multiple.case1'>
                  <td>1</td>
                  <td>
                    <button type="button" class="btn btn-outline-secondary">編輯</button>
                  </td>
                  <td>紅</td>
                  <td>20</td>
                  <td>18</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="stockStatus === 3">
      <div class="d-flex flex-column flex-fill">
        <div class="d-flex flex-column  border-bottom">
          <div class="d-flex align-items-center pt-1">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">總庫存量：</span>
            <div>
              <b-input></b-input>
            </div>
            <span>（不得超過元素最低總庫存量）</span>
          </div>
          <div class="d-flex align-items-center pl-3 mt-1">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="sotckCheck8" />
              <label class="form-check-label" for="sotckCheck8">安全庫存停賣點：</label>
            </div>
            <div>
              <b-input></b-input>
            </div>
          </div>
          <div class="d-flex flex-fill flex-column align-items-start pl-3 mt-1">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="sotckCheck9" />
              <label class="form-check-label" for="sotckCheck9">是否顯示庫存量</label>
            </div>
            <!-- <div class="d-flex align-items-center pl-4 mt-1">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value id="sotckCheck10" />
                <label class="form-check-label" for="sotckCheck10">自訂庫存量</label>
              </div>
              <div>
                <b-input></b-input>
              </div>
            </div> -->
            <div class="d-flex align-items-center mt-1">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value id="sotckCheck11" />
                <label class="form-check-label" for="sotckCheck11">顯示上架日</label>
              </div>
            </div>
          </div>
          <span class="align-self-start">【元素庫存狀態】</span>
          <div class="d-flex flex-fill">
            <table class="table table-bordered">
              <thead align="left">
                <tr>
                  <th></th>
                  <th>元素</th>
                  <th>所在方案</th>
                  <th>剩餘（總庫存量）</th>
                  <th>安全停賣點</th>
                  <th>庫存狀態</th>
                </tr>
              </thead>
              <tbody align="left">
                <tr>
                  <td></td>
                  <td>課程</td>
                  <td>單, A, B, C</td>
                  <td>40（50）</td>
                  <td>48</td>
                  <td>尚可</td>
                </tr>
                <tr>
                  <td></td>
                  <td>有聲書</td>
                  <td>A, B, C</td>
                  <td>80（100）</td>
                  <td>90</td>
                  <td>尚可</td>
                </tr>
                <tr>
                  <td></td>
                  <td>函授</td>
                  <td>B, C</td>
                  <td>10（100）</td>
                  <td>無</td>
                  <td>尚可</td>
                </tr>
                <tr>
                  <td></td>
                  <td>回訓</td>
                  <td>C</td>
                  <td>48（50）</td>
                  <td>無</td>
                  <td>尚可</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <editEle :show.sync='openeditEle.show' :method='openeditEle.type' @save="saveElement">
    </editEle>
    <selectEle :show.sync='openeditEle.importEleShow' @save="saveselectElement"
      :selectdata="openeditEle.importSelectList">
    </selectEle>
  </div>

  <!-- <div class="d-flex justify-content-center">
    <div class="Stock d-flex flex-column">
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">總庫存量</div>
        <div class="d-flex flex-column text-left flex-fill">
          <div class="d-flex justify-content-start align-items-center">
            <input type="text" class="form-control" />
            <small>(正負數)</small>
          </div>
          <div>
            <ul>
              <li>不輸入表示不使用庫存</li>
              <li>
                當有輸入時，購物完成或店家於後台修改訂單購買數量後，系統會自動校正庫存量<br />刪除或取消訂單時系統會詢問是否加回庫存
              </li>
              <li>
                另可於 [批次編輯商品] [庫存] 點左上方 [安全庫存量通知] 設定提示<br />或於
                [庫存量排行] 查詢庫存不足的商品
              </li>
            </ul>
          </div>
          <div class="d-flex">
            <b-form-checkbox
              id="checkbox-1"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
              v-model="stockempty"
            >
              當庫存量小於等於 0 時，自動停賣<br />停賣時隱藏訂購鈕，並顯示
            </b-form-checkbox>
            <div class="d-flex align-self-end">
              <b-form-radio value="SoldOut" name="stockradio">已售完</b-form-radio>
              <b-form-radio value="replenishment" name="stockradio">售完補貨中</b-form-radio>
              <b-form-radio value="PreSale" name="stockradio">預售中</b-form-radio>
            </div>
          </div>
          <div>
            <ul>
              <li>不勾選時：即使庫存小於 0 時消費者仍可購買</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">其他</div>
        <div class="d-flex flex-column text-left flex-fill">
          <b-form-checkbox-group
            class="d-flex flex-column text-left flex-fill"
            v-model="stockShow"
            name="flavour-2"
          >
            <b-form-checkbox value="showStock">顯示庫存量讓消費者看</b-form-checkbox>
            <b-form-checkbox value="showOnDate">顯示上架日期讓消費者看</b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </div>
    </div>
  </div>-->
</template>
<script>
  import ctrl from './insStock.js'
  export default ctrl;

</script>
<style lang="scss"></style>
